import { Component, OnInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { AppSettings } from './enums/app-settings.enum';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ModalController } from '@ionic/angular';
import {
  ActivatedRoute,
  NavigationStart,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesService } from './utilities/utilities.service';
import { LanguageSwitchService } from './services/language-switch.service';
import { Subject } from 'rxjs';
// import { DOCUMENT } from '@angular/common';
import { ProductService } from './services/product.service';
declare var document: any;

import { ApplicationInitializationService } from './services/application-initialization.service';
import { AdobeAnalyticsService } from './services/adobe-analytics.service';
import { filter } from 'rxjs/operators';
import { UrlService } from './services/url.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'planscartandcheckout';
  loaderColor: string = AppSettings.LOADER_COLOR;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  private destroy$ = new Subject<void>();
  URLS: any;
  currentUrl: string = null;
  productDetailsPageList: string[] = ['cart'];
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private router: Router,
    private UTS: UtilitiesService,
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private AAS: AdobeAnalyticsService,
    private urlService: UrlService,
    private R: Renderer2,
    private productService: ProductService,
    private applicationInitializationService: ApplicationInitializationService,
    private GAS: GoogleAnalyticsService
  ) {
    this.UTS.log(
      'BUILD 0.0.45 DEPLOYED 11-07-2024 PRODUCTION BUILD'
    );
    this.route.queryParamMap.subscribe((params) => {
      this.route.queryParams.subscribe((q) => {
        if (q && q.env) {
          if (q.env == 'mobile') {
            localStorage.clear();
            this.UTS.deleteAllCookies();
            if (q && q['env']) {
              this.UTS.setENV(q['env']);
            }
            if (q && q['enableTabby'] == 'true') {
              sessionStorage.setItem(
                'enableTabby',
                q['enableTabby']
              );
            }
            setTimeout(() => {
              this.UTS.initializeFromQueryParams(q);
              if (q && q['JSESSIONID']) {
                sessionStorage.setItem('JSID',q['JSESSIONID']);
                sessionStorage.setItem(
                  'JSID_SET_TIME',
                  Number(Date.now()).toString()
                );
              }
              if (q && q['guestMode'] == 'true') {
                sessionStorage.setItem('guestMode', q['guestMode']);
                if (
                  q &&
                  q['3MonthsFreePromoForXAA'] &&
                  q['3MonthsFreePromoForXAA'] == 'true'
                ) {
                  if (q['skuId']) {
                    sessionStorage.setItem(
                      '3MonthsFreePromoForXAA' + q['skuId'],
                      q['3MonthsFreePromoForXAA']
                    );
                  }
                }
              }
              if (q && q['guestMode'] == 'false') {
                sessionStorage.setItem('guestMode', q['guestMode']);
                if (q && q['userRegistrationAccountNoFromMobEnv']) {
                  sessionStorage.setItem(
                    'userRegistrationAccountNoFromMobEnv',
                    q['userRegistrationAccountNoFromMobEnv']
                  );
                }
              }
              if (q && q['enableTabby'] == 'true') {
                sessionStorage.setItem(
                  'enableTabby',
                  q['enableTabby']
                );
              }
            }, 500);
            // setTimeout(() => {
            //   this.getAccount();
            // }, 500);
          }
        }
        if (q && (q.simType || q.userFrom || q.email)) {
          const { simType = null, userFrom = null, email = null } = q;
          this.UTS.setPlanData({ simType, userFrom, email });
          console.log('Plan data stored:', { simType, userFrom, email });
        }
      });
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = parentLanguage
        ? parentLanguage.toLocaleLowerCase()
        : 'english';
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
        ? token.params.lang.toLowerCase()
        : localLanguage
        ? localLanguage.toLocaleLowerCase()
        : 'en';
      if (lang === 'ar' || parentLang === 'arabic') {
        localStorage.removeItem('language');
        this.LSS.setLanguage('ar');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
        this.URLS = {
          APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
        };
      } else {
        localStorage.removeItem('language');
        this.LSS.setLanguage('en');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
        this.URLS = {
          APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'en' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
        };
      }
    });
    // sets an idle timeout of 10 seconds.
    idle.setIdle(AppSettings.SESSION_IDLE_TIME);
    idle.setTimeout(AppSettings.SESSION_KEEP_ALIVE_TIME);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => (this.idleState = 'No longer idle.'));

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
    });
    idle.onIdleStart.subscribe(() => (this.idleState = 'idle state'));

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      if (countdown == 15) {
        this.UTS.openSessionTimeout();
      }
    }); // sets the ping interval to 15 seconds
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {

        this.GAS.trackScreen(this.router.url);
      }
    });
    keepalive.interval(20);
    this.reset();
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  ngAfterViewInit() {
    // this.UTS.getHeaders();
    setTimeout(() => {
      this.setPageOritentation(this.LSS.getLanguage());
    }, 500);
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  public getHeaderURL() {
    return this.UTS.getAHURL();
  }

  public getFooterURL() {
    return this.UTS.getAFURL();
  }
  public getNavigationURL() {
    return this.UTS.getANURL();
  }

  setPageOritentation(lang) {
    if (lang == 'ar') {
      this.R.setAttribute(document.documentElement, 'lang', 'ar');
      this.R.setAttribute(document.body, 'dir', 'rtl');
    } else {
      this.R.setAttribute(document.documentElement, 'lang', 'en');
      this.R.setAttribute(document.body, 'dir', 'ltr');
    }
  }

  getHeaderLibs(headerUrl) {
    this.productService.getLibs('/' + headerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          const scriptRegex =
            /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          const filteredHtml = res.htmlSrc.replace(scriptRegex, '');

          let headData = document.getElementsByTagName('head')[0].innerHTML;
          headData = filteredHtml + headData;
          document.getElementsByTagName('head')[0].innerHTML = headData;

          this.loadScripts(res.htmlSrc, document.getElementById('headerLibs'));

          const requireScript = '/b2c/hshopApp/assets/js/require.min.js';
          this.loadScript(requireScript);
        }
      },
      (e) => {
        this.UTS.log('failed to retrive header libs');
      }
    );
  }
  getFooterLibs(footerUrl) {
    this.productService.getCMSContent('/' + footerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('footerLibs'));
        }
      },
      (e) => {
        this.UTS.log('failed to retrive footer libs');
      }
    );
  }

  loadScripts(htmlStr: string, targetEl: any) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');
    for (let index = 0; index < html?.scripts.length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      this.R.appendChild(targetEl, scriptTag);
    }

    // for (let index = 0; index < html.links.length; index++) {
    //   const link = html.links[index];
    //   let linkTag = this.R.createElement('link');
    //   linkTag.rel = "stylesheet"
    //   linkTag.href = link.href;
    //   linkTag.type = 'text/css';
    //   this.R.appendChild(targetEl, linkTag);
    // }
  }

  ngOnInit(): void {
    this.loadScript(
      'https://maps.google.com/maps/api/js?key=' +
        this.applicationInitializationService?.environmentConfig?.MAP_KEY +
        '&libraries=places,visualization,drawing,geometry,places'
    ).then(() => {});
    // this.loadScript('https://www.googletagmanager.com/gtm.js?id=' + this.applicationInitializationService?.environmentConfig?.GTM).then(() => {
    // });
    // this.loadGTM()
    // this.loadNoScriptTag()
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if(event) {
          const pathName = event.url.split('?')[0].replace('/','');
          const pageName = window.location.host + ':' + pathName;
          this.urlService.setPreviousUrl(this.currentUrl ? this.currentUrl : '');
          this.currentUrl = event.url;
          if(!this.productDetailsPageList.includes(pathName)) {
            this.AAS.pageLoadedEvent(pageName, document.title, false, null);
          }
        }
      });
    this.loadScript(
      this.applicationInitializationService?.environmentConfig?.ADOBE_SCRIPT
    );
    const ENV = this.UTS.getENV();
    if (ENV != 'mobile') {
      this.getHeaderLibs(AppSettings.HEADER_LIBS);
      this.getFooterLibs(AppSettings.FOOTER_LIBS);
    }
  }

  loadScript(src: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
      resolve('');
    });
  }

  loadGTM() {
    var ele = document.createElement('script');
    ele.text =
      "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" +
      this.applicationInitializationService?.environmentConfig?.GTM +
      "')";
    window.document.head.appendChild(ele);
  }

  loadNoScriptTag() {
    var noscript = document.createElement('noscript');
    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      'https://www.googletagmanager.com/ns.html?id=' +
        this.applicationInitializationService?.environmentConfig?.GTM
    );
    iframe.setAttribute('height', '0');
    iframe.setAttribute('width', '0');
    iframe.setAttribute('style', 'display:none;visibility:hidden');
    noscript.appendChild(iframe);
    window.document.body.appendChild(noscript);
  }
}

function Inject(DOCUMENT: any) {
  throw new Error('Function not implemented.');
}
